import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { modalActions } from 'store/modal'
import STRINGS from 'utils/strings'
import { fetchParticipantVisits } from '../../../../../../Participants/routes/CreateParticipant/modules/CreateParticipant'
import { getUserRoleIdByStudy } from 'utils/misc'
import { isIrtControlledVisitRestricted } from 'utils/studyConfigUtils'
import { getLastPathSegment } from 'utils/navigation'
import { getHeaderName } from '../../../../../utils/visitNameUtils'
import { participantVisitActions } from '../modules/ParticipantVisit'
import ParticipantVisitPage from '../components/ParticipantVisitPage'
import { parseParticipantVisitKey } from '../utils/participantVisitRouteUtils'

const mapDispatchToProps = { ...participantVisitActions, fetchParticipantVisits, ...modalActions }

const getFilterPtpVisits = (ptpVisits, isUpdate, ssvpID) =>
  isUpdate ? ptpVisits.filter(visitArr => visitArr[0].visitId !== ssvpID) : ptpVisits

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { params } = ownProps
  const { ptpID, ssvpID } = parseParticipantVisitKey(params?.visitKey)
  const { loading, location, study, subroute, participantVisitReducer, participantReducer, studyLock, user, visitSchedules } =
    state
  const { currentStudy, studyVersionList } = study
  const path = getLastPathSegment(location?.pathname)
  const isUpdate = path === 'edit'
  const studyID = currentStudy.id
  const { config = {} } = currentStudy
  const disableSubsequentVisitAdjustment = config.visit_support?.disable_subsequent_visit_adjustment
  const roleId = getUserRoleIdByStudy(user, studyID)
  const isIrtControlledVisitReadOnly =
    isUpdate &&
    isIrtControlledVisitRestricted({
      config,
      studyVersionList,
      studyVersionID,
      roleId,
      visitId: ssvpID,
      participantVisitMetadata: participantVisitReducer?.visit_metadata,
      studyScheduleVisitId: participantVisitReducer?.studyScheduleVisitId,
      studyVisitSchedule: visitSchedules?.studyVisitSchedule,
    })

  return {
    disabled: studyLock || isIrtControlledVisitReadOnly,
    isIrtControlledVisitReadOnly,
    disableSubsequentVisitAdjustment,
    errors: participantVisitReducer.participantVisitErrors,
    subtitleName: getHeaderName(path, subroute),
    isLoading: loading.general,
    isUpdate,
    ptpID,
    ptpVisitsLoading: loading.participantVisits,
    participantVisitList: getFilterPtpVisits(participantReducer.participantVisits, isUpdate, ssvpID),
    participantVisitsArray: participantVisitReducer.participantVisits,
    ...participantVisitReducer,
    path,
    STRINGS,
    studyID,
    ssvpID,
    visitorParticipantLoader: loading.visitorParticipant,
    studyVersionID,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return props.isLoading ? <Loader active /> : <ParticipantVisitPage {...props} />
})
